export class AppConstants {
    public static get baseURL(): string { return 'http://localhost:4200/api'; }
    public static get httpError(): string { return 'Der er sket en HTTP fejl.'; }
    public static get typeError(): string { return 'Der er sket en Type fejl.'; }
    public static get generalError(): string { return 'Der er sket en general fejl.'; }
    public static get somethingHappened(): string { return 'Ingen har kastet en fejl- men noget er sket.'; }
    }